import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const Services: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4">
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Coming Soon
            </h1>
            <div className="w-24 h-1 bg-[#d40715] mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              We're working on something exciting! Our services page will be available soon.
            </p>
          </div>
        </div>
      </div>
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default Services;